import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class ServiceRiskTypesMultiSelectListCtrl implements IController {
  riskTypes: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;
  public isSelectAll: boolean;

  /* @ngInject */
  constructor(private deliveriesConstants, private commonsService: CommonsService) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.deliveriesConstants.riskTypes;
    }
  }

  $onChanges(changes) {
    if (changes.riskTypes) {
      this.selectedKeys = [];
      _.forEach(this.riskTypes, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      riskTypes: isSelected ? _.concat(this.riskTypes, [option]) :
        _.filter(this.riskTypes, (type) => {
          return type !== option;
        })
    });
  }

  onReset() {
    this.onChange({riskTypes: []});
  }

  submitQuery(query) {
    this.queryString = query;
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onReset();
    } else {
      const options = this.options?.filter(o => {
        return this.queryString ? _.includes(o.toLowerCase(), this.queryString.toLowerCase()) : o;
      });
      this.onChange({riskTypes: options || []});
    }
  }


  isAllSelected() {
    const options = this.options?.filter(o => {
      return this.queryString ? _.includes(o.toLowerCase(), this.queryString.toLowerCase()) : o;
    });
    this.isSelectAll = this.commonsService.checkIfArraysMatch(options, this.riskTypes);
    return this.isSelectAll;
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceRiskTypesMultiSelectList', {
    bindings: {
      riskTypes: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./service-risk-types-multi-select-list.html').default,
    controller: ServiceRiskTypesMultiSelectListCtrl
  });
